import { render, staticRenderFns } from "./needMatter.vue?vue&type=template&id=089b0ece&scoped=true&"
import script from "./needMatter.vue?vue&type=script&lang=js&"
export * from "./needMatter.vue?vue&type=script&lang=js&"
import style0 from "./needMatter.vue?vue&type=style&index=0&id=089b0ece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089b0ece",
  null
  
)

export default component.exports